// src/components/Header.js

import React from 'react';
import './Header.css';
import ThemeToggle from './ThemeToggle';

const Header = ({ date }) => {
  const currentDate = new Date(date);
  const baseDate = new Date('2025-04-05');
  const diffTime = currentDate - baseDate;
  const edition = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

  return (
    <header className="header">
      <div className="header-content">
        <div className="masthead">
          <h1 className="title">Skimz</h1>
          <p className="subtitle">Built for Brains in a Hurry | No Fluff, Just Facts.</p>
        </div>
        <div className="header-controls">
          <div className="date-block">
            <p className="header-edition">{`Edition #${edition}`}</p>
            <p className="date">{date}</p>
          </div>
          <div className="theme-toggle-container">
            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
